import React from "react";
import axios from "axios";
import useAuth from '../hooks/useAuth';
import {Link, useLocation, useNavigate} from 'react-router-dom';
import useDocumentTitle from "../hooks/useDocumentTitle";
import {EmailIcon, PhoneIcon, UserIcon, HomeIcon} from "../assets/icons";
import ModalAjax from "../components/main/ModalAjax";
import AuthApi from "../api/AuthApi";
import { notification } from "antd";
import {EmailFunc} from "../func/StringFunc";

const RegisterPage = () => {

    useDocumentTitle('Регистрация');
    const [apiNotification, contextHolder] = notification.useNotification();
    const {setAuth, setRoles, setUser} = useAuth();
    const navigate = useNavigate();
    const loginRef = React.useRef(null);
    const passwordRef = React.useRef(null);
    const [ isErrorName, setIsErrorName ] = React.useState(false);
    const [ isErrorSurname, setIsErrorSurname ] = React.useState(false);
    const [ isErrorFatherName, setIsErrorFatherName ] = React.useState(false);
    const [ isErrorLogin, setIsErrorLogin ] = React.useState(false);
    const [ isErrorEmail, setIsErrorEmail ] = React.useState(false);
    const [ isErrorVerifyCode, setIsErrorVerifyCode ] = React.useState(false);
    const [isAgreePersonalData, setIsAgreePersonalData] = React.useState(false);
    const [isAgreePrivacyPolicy, setIsAgreePrivacyPolicy] = React.useState(false);
    const [isAgreeOffer, setIsAgreeOffer] = React.useState(false);
    const [ isSendCode, setIsSendCode ] = React.useState(false);
    const [ isOpenUserInfo, setIsOpenUserInfo ] = React.useState(false);
    const [valueName, setValueName] = React.useState('');
    const [valueSurname, setValueSurname] = React.useState('');
    const [valueFatherName, setValueFatherName] = React.useState('');
    const [valueCompany, setValueCompany] = React.useState('');
    const [valueLogin, setValueLogin] = React.useState('+7 ');
    const [valueEmail, setValueEmail] = React.useState('');
    const [valueVerifyCode, setValueVerifyCode] = React.useState('');
    const [userId, setUserId] = React.useState(0);
    const register = () => {

        let isError = false;

        setIsErrorLogin(false);
        setIsErrorEmail(false);
        setIsErrorName(false);
        setIsErrorSurname(false);
        setIsErrorFatherName(false);

        if (valueName === '') {
            isError = true;
            setIsErrorName(true);
        }

        if (valueSurname === '') {
            isError = true;
            setIsErrorSurname(true);
        }

        if (valueFatherName === '') {
            isError = true;
            setIsErrorFatherName(true);
        }

        if (valueLogin === '' || valueLogin.length < 11) {
            isError = true;
            setIsErrorLogin(true);
        }

        if (valueEmail === '' || !EmailFunc.isValid(valueEmail)) {
            isError = true;
            setIsErrorEmail(true);
        }

        if (!isAgreePersonalData || !isAgreePrivacyPolicy || !isAgreeOffer) {
            isError = true;
        }

        if (!isError) {

            AuthApi.register(valueLogin, valueEmail, valueName, valueSurname, valueFatherName, valueCompany).then((data) => {
                if (data.status === 'success') {
                    setIsSendCode(true);
                    setUserId(data.content.id);
                }
            });

        } else {
            apiNotification['error']({
                message: 'Ошибка',
                description:
                    !isAgreePersonalData || !isAgreePrivacyPolicy || !isAgreeOffer
                        ? 'Необходимо подтвердить все три согласия перед продолжением'
                        : 'Пожалуйста, заполните все обязательные поля отмеченные *',
            });
        }
    }

    const verify = () => {
        if (valueVerifyCode === '') {
            setIsErrorVerifyCode(true);
            apiNotification['error']({
                message: 'Ошибка',
                description:
                    'Пожалуйста, введите код из SMS или E-mail',
            });
        } else {
            AuthApi.verify(userId, valueVerifyCode).then((data) => {
                if (data.status === 'success' && data.content.token) {
                    localStorage.setItem('token', data.content.token);
                    setAuth(true);
                    let roles = ['ROLE_USER'];
                    if (data.content.roles) {
                        localStorage.setItem('roles', JSON.stringify(data.content.roles));
                        setRoles(data.content.roles);
                        let currentUser = {
                            id: data.content.id,
                            login: data.content.login,
                            name: data.content.name
                        }
                        localStorage.setItem('user', JSON.stringify(currentUser));
                        setUser(currentUser);
                    }
                    navigate('/cabinet/profile', { replace: true });
                } else {
                    setIsErrorVerifyCode(true);
                    apiNotification['error']({
                        message: 'Ошибка',
                        description:
                            'Код указан неверно. Пожалуйста, попробуйте еще раз',
                    });
                }
            });
        }
    }

    const handleChange = (event) => {

        let formatted = '';

        let numbersOnly = event.target?.value.replace(/\D/g, '');

        if (numbersOnly.length > 0) {
            formatted += '+7 ';
        }
        if (numbersOnly.length > 1) {
            formatted += '(' + numbersOnly.substring(1, 4);
        }
        if (numbersOnly.length > 4) {
            formatted += ') ' + numbersOnly.substring(4, 7);
        }
        if (numbersOnly.length > 7) {
            formatted += '-' + numbersOnly.substring(7, 9);
        }
        if (numbersOnly.length > 9) {
            formatted += '-' + numbersOnly.substring(9, 11);
        }


        setValueLogin(formatted);
    }

    const handleChangeEmail = (event) => {
        let result = event.target?.value;
        setValueEmail(result);
    }

    const handleChangeVerifyCode = (event) => {
        let result = event.target?.value;
        setValueVerifyCode(result);
    }

    return (
        <div className="w-full max-w-[26rem] p-4 sm:px-5">
            {contextHolder}
            <div className="text-center">
                <img
                    className="mx-auto h-16 w-16"
                    src="/icon.png"
                    alt="logo"
                />
                <div className="mt-4">
                    <h2 className="text-2xl font-semibold text-slate-600 dark:text-navy-100">
                        Регистрация
                    </h2>
                    <p className="text-slate-400 dark:text-navy-300">
                        Создание нового аккаунта
                    </p>
                </div>
            </div>
            <div className="card mt-5 rounded-lg p-5 lg:p-7">
                {
                    !isSendCode ?
                        <div>
                            <label className="block">
                                <span>Ваше имя: *</span>
                                <span className="relative mt-1.5 flex">
                <input
                    className={`form-input peer w-full rounded-lg border border-${isErrorName ? 'error bg-error' : 'slate-300 bg-transparent'} px-3 py-2 pl-9 placeholder:text-slate-400/70 hover:border-slate-400 focus:border-primary dark:border-navy-450 dark:hover:border-navy-400 dark:focus:border-accent`}
                    placeholder=""
                    type="text"
                    onChange={(e) => setValueName(e.target.value)}
                    value={valueName}
                />
                <span
                    className="pointer-events-none absolute flex h-full w-10 items-center justify-center text-slate-400 peer-focus:text-primary dark:text-navy-300 dark:peer-focus:text-accent">
                    <UserIcon/>
                </span>
              </span>
                            </label>
                            <label className="block mt-4">
                                <span>Фамилия: *</span>
                                <span className="relative mt-1.5 flex">
                <input
                    className={`form-input peer w-full rounded-lg border border-${isErrorSurname ? 'error bg-error' : 'slate-300'} bg-transparent px-3 py-2 pl-9 placeholder:text-slate-400/70 hover:border-slate-400 focus:border-primary dark:border-navy-450 dark:hover:border-navy-400 dark:focus:border-accent`}
                    placeholder=""
                    type="text"
                    onChange={(e) => setValueSurname(e.target.value)}
                    value={valueSurname}
                />
                <span
                    className="pointer-events-none absolute flex h-full w-10 items-center justify-center text-slate-400 peer-focus:text-primary dark:text-navy-300 dark:peer-focus:text-accent">
                    <UserIcon/>
                </span>
              </span>
                            </label>
                            <label className="block mt-4">
                                <span>Отчество: *</span>
                                <span className="relative mt-1.5 flex">
                <input
                    className={`form-input peer w-full rounded-lg border border-${isErrorFatherName ? 'error bg-error' : 'slate-300'} bg-transparent px-3 py-2 pl-9 placeholder:text-slate-400/70 hover:border-slate-400 focus:border-primary dark:border-navy-450 dark:hover:border-navy-400 dark:focus:border-accent`}
                    placeholder=""
                    type="text"
                    onChange={(e) => setValueFatherName(e.target.value)}
                    value={valueFatherName}
                />
                <span
                    className="pointer-events-none absolute flex h-full w-10 items-center justify-center text-slate-400 peer-focus:text-primary dark:text-navy-300 dark:peer-focus:text-accent">
                    <UserIcon/>
                </span>
              </span>
                            </label>
                            <label className="block mt-4">
                                <span>Компания:</span>
                                <span className="relative mt-1.5 flex">
                <input
                    className={`form-input peer w-full rounded-lg border border-slate-300 bg-transparent px-3 py-2 pl-9 placeholder:text-slate-400/70 hover:border-slate-400 focus:border-primary dark:border-navy-450 dark:hover:border-navy-400 dark:focus:border-accent`}
                    placeholder=""
                    type="text"
                    onChange={(e) => setValueCompany(e.target.value)}
                    value={valueCompany}
                />
                <span
                    className="pointer-events-none absolute flex h-full w-10 items-center justify-center text-slate-400 peer-focus:text-primary dark:text-navy-300 dark:peer-focus:text-accent">
                    <HomeIcon/>
                </span>
              </span>
                            </label>
                        <label className="block mt-4">
                            <span>Номер телефона: *</span>
                            <span className="relative mt-1.5 flex">
                <input ref={loginRef}
                       className={`form-input peer w-full rounded-lg border border-${isErrorLogin ? 'error bg-error' : 'slate-300'} bg-transparent px-3 py-2 pl-9 placeholder:text-slate-400/70 hover:border-slate-400 focus:border-primary dark:border-navy-450 dark:hover:border-navy-400 dark:focus:border-accent`}
                       placeholder=""
                       type="text"
                       onChange={handleChange}
                       value={valueLogin}
                />
                <span className="pointer-events-none absolute flex h-full w-10 items-center justify-center text-slate-400 peer-focus:text-primary dark:text-navy-300 dark:peer-focus:text-accent">
                    <PhoneIcon />
                </span>
              </span>
                        </label>
                            <label className="mt-4 block">
                                <span>E-mail: *</span>
                                <span className="relative mt-1.5 flex">
                <input
                       className={`form-input peer w-full rounded-lg border border-${isErrorEmail ? 'error bg-error' : 'slate-300'} bg-transparent px-3 py-2 pl-9 placeholder:text-slate-400/70 hover:border-slate-400 focus:border-primary dark:border-navy-450 dark:hover:border-navy-400 dark:focus:border-accent`}
                       placeholder=""
                       type="text"
                       onChange={handleChangeEmail}
                       value={valueEmail}
                />
                <span className="pointer-events-none absolute flex h-full w-10 items-center justify-center text-slate-400 peer-focus:text-primary dark:text-navy-300 dark:peer-focus:text-accent">
                    <EmailIcon />
                </span>
              </span>
                            </label>
                            <label className="block mt-4 flex items-center gap-4">
                            <span>
                                <input
                                    type={'checkbox'}
                                    checked={isAgreePersonalData}
                                    onChange={(e) => setIsAgreePersonalData(e.target.checked)}
                                />
                            </span>
                                <span>
                                Согласен на <a class={'underline'} href={'https://kmos-perm.com/wp-content/uploads/2026/04/Soglasie-na-obrabotku-personalnyh-dannyh.pdf'} target={'_blank'}>обработку персональных данных</a>
                            </span>
                            </label>
                            <label className="block mt-1 flex items-center gap-4">
                            <span>
                                <input
                                    type={'checkbox'}
                                    checked={isAgreePrivacyPolicy}
                                    onChange={(e) => setIsAgreePrivacyPolicy(e.target.checked)}
                                />
                            </span>
                                <span>
                                Согласен с <a class={'underline'} href={'https://kmos-perm.com/wp-content/uploads/2026/04/Politika-v-otnoshenii-personalnyh-dannyh.pdf'} target={'_blank'}>условиями политики конфедициальности</a>
                            </span>
                            </label>
                            <label className="block mt-1 flex items-center gap-4">
                            <span>
                                <input
                                    type={'checkbox'}
                                    checked={isAgreeOffer}
                                    onChange={(e) => setIsAgreeOffer(e.target.checked)}
                                />
                            </span>
                                <span>
                                Согласен с <a class={'underline'} href={'https://kmos-perm.com/wp-content/uploads/2026/04/Dogovor-oferty.pdf'} target={'_blank'}>условиями договора оферты</a>
                            </span>
                            </label>
                        </div>
                        :
                <label className="mt-4 block">
                    <span>Код подтверждения:</span>
                    <span className="relative mt-1.5 flex">
                <input ref={passwordRef}
                    className={`form-input peer w-full rounded-lg border border-${isErrorVerifyCode ? 'error bg-error' : 'slate-300'} bg-transparent px-3 py-2 pl-9 placeholder:text-slate-400/70 hover:border-slate-400 focus:border-primary dark:border-navy-450 dark:hover:border-navy-400 dark:focus:border-accent`}
                    placeholder="Введите код из SMS или E-mail"
                    type="text"
                       onChange={handleChangeVerifyCode}
                       value={valueVerifyCode}
                />
                <span
                    className="pointer-events-none absolute flex h-full w-10 items-center justify-center text-slate-400 peer-focus:text-primary dark:text-navy-300 dark:peer-focus:text-accent"
                >
                  <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 transition-colors duration-200"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                  >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                        d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                    />
                  </svg>
                </span>
              </span>
                </label>
                }
                {
                    isSendCode ?
                        <button onClick={verify}
                                className="btn mt-5 w-full bg-primary font-medium text-white hover:bg-primary-focus focus:bg-primary-focus active:bg-primary-focus/90 dark:bg-accent dark:hover:bg-accent-focus dark:focus:bg-accent-focus dark:active:bg-accent/90">
                            Подтвердить
                        </button>
                        :
                        <button onClick={register}
                                className="btn mt-5 w-full bg-primary font-medium text-white hover:bg-primary-focus focus:bg-primary-focus active:bg-primary-focus/90 dark:bg-accent dark:hover:bg-accent-focus dark:focus:bg-accent-focus dark:active:bg-accent/90">
                            Далее
                        </button>
                }
                <div className="mt-4 text-center text-xs+">
                    <p className="line-clamp-1">
                        <span>Есть аккаунта?</span>&nbsp;

                        <Link className="text-primary transition-colors hover:text-primary-focus dark:text-accent-light dark:hover:text-accent" to="/auth/login">
                            Авторизация
                        </Link>
                    </p>
                </div>
            </div>
            <div className="mt-8 flex justify-center text-xs text-slate-400 dark:text-navy-300">
                <a href="#" onClick={() => setIsOpenUserInfo(true)}>Пользовательское соглашение</a>
            </div>
            <ModalAjax source={"term_of_use"} isOpen={isOpenUserInfo} onClose={() => setIsOpenUserInfo(false)}/>
        </div>
    );

}

export default RegisterPage;
